module.exports = __webpack_public_path__ + "img/primary_9x4_z18.1559fa86.svg";